// extracted by mini-css-extract-plugin
module.exports = {"groupEditor":"AdminGroupEdit_groupEditor__zFkRj","fullcol":"AdminGroupEdit_fullcol__3Ybb9","lcol":"AdminGroupEdit_lcol__3ohb-","rcol":"AdminGroupEdit_rcol__2CJos"};